import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { AgentManagedBlockLifecycleState } from './agentManagedExtensionPluginType';

export const isExecutingLifecycleState = (
	lifecycleState: AgentManagedBlockLifecycleState | undefined,
): lifecycleState is 'no-body-executing' | 'existing-body-executing' =>
	lifecycleState === 'no-body-executing' || lifecycleState === 'existing-body-executing';

export const hasGeneratedBodyContent = (node: PMNode): boolean => {
	if (node.childCount === 0) {
		return false;
	}

	if (node.childCount !== 1) {
		return true;
	}

	// If only one child that's a paragraph, don't count it
	const onlyChild = node.child(0);
	return !(onlyChild.type.name === 'paragraph' && onlyChild.childCount === 0);
};

export const getExecutionLifecycleState = (node: PMNode): AgentManagedBlockLifecycleState =>
	hasGeneratedBodyContent(node) ? 'existing-body-executing' : 'no-body-executing';

export const getAgentManagedBlockLifecycleState = ({
	hasLocalExecutionError,
	node,
	transientLifecycleState,
}: {
	hasLocalExecutionError?: boolean;
	node: PMNode;
	transientLifecycleState?: AgentManagedBlockLifecycleState;
}): AgentManagedBlockLifecycleState => {
	if (isExecutingLifecycleState(transientLifecycleState)) {
		return transientLifecycleState;
	}

	if (hasLocalExecutionError) {
		return 'execution-error';
	}

	return hasGeneratedBodyContent(node) ? 'generated' : 'idle';
};
